export const getWindow = () => global.window;